const data = {
  mapArea: document.getElementById('map'),
  mapImages: document.querySelectorAll('[data-role="area-img"]'),
  mapCks: document.querySelectorAll('[data-role="area-ck"]'),
};

data.mapImages.forEach(function (mapImage) {
  mapImage.addEventListener('click', function () {
    // クリックした画像の data-area-id を取得
    const clickImageId = mapImage.getAttribute('data-area-id');

    if (mapImage.classList.contains('is-active')) {
      mapImage.classList.remove('is-active');
      data.mapCks.forEach(function (mapCkElement) {
        const mapCkId = mapCkElement.getAttribute('data-area-id');
        if (mapCkId === clickImageId) {
          mapCkElement.classList.remove('is-active'); // 要素にクラスをトグル
          mapCkElement.checked = false;
        }
      });
    } else {
      mapImage.classList.add('is-active');

      data.mapCks.forEach(function (mapCkElement) {
        const mapCkId = mapCkElement.getAttribute('data-area-id');
        if (mapCkId === clickImageId) {
          mapCkElement.classList.add('is-active'); // 要素にクラスをトグル
          mapCkElement.checked = true;
        }
      });
    }
  });
});

data.mapCks.forEach(function (mapCk) {
  mapCk.addEventListener('click', function () {
    // クリックした画像の data-area-id を取得
    const clickCkId = mapCk.getAttribute('data-area-id');

    if (mapCk.classList.contains('is-active')) {
      mapCk.classList.remove('is-active');
      data.mapImages.forEach(function (mapImageElement) {
        const mapImageID = mapImageElement.getAttribute('data-area-id');
        if (clickCkId === mapImageID) {
          mapImageElement.classList.remove('is-active'); // 要素にクラスをトグル
        }
      });
    } else {
      mapCk.classList.add('is-active');
      data.mapImages.forEach(function (mapImageElement) {
        const mapImageID = mapImageElement.getAttribute('data-area-id');
        if (clickCkId === mapImageID) {
          mapImageElement.classList.add('is-active'); // 要素にクラスをトグル
        }
      });
    }
  });
});
